import { render, staticRenderFns } from "./ShareModule.vue?vue&type=template&id=79f34f10&"
import script from "./ShareModule.ts?vue&type=script&lang=ts&"
export * from "./ShareModule.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports